import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Eye, ShieldCheck, Truck, Phone } from "lucide-react";
import { api, COMPANY } from "@/lib/api";
import OccasionCard from "@/components/occasion/OccasionCard";
import { OCC_BASE } from "@/lib/occasions";

const POINTS = [
  [Eye, "Visibles et essayables à Bourgoin-Jallieu"],
  [ShieldCheck, "Heures, entretien et chenilles indiqués"],
  [Truck, "Livraison partout en France"],
];

export default function HomeOccasions() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/occasions").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  const shown = (items || []).slice(0, 6);
  const dispo = (items || []).filter((o) => o.statut !== "vendu").length;

  return (
    <section className="lmb-section bg-white" data-testid="home-occasions">
      <div className="lmb-container">
        <div className="grid lg:grid-cols-[1fr_auto] gap-6 items-end mb-10 sm:mb-12">
          <div className="max-w-3xl">
            <div className="text-xs font-mono-tech tracking-[0.2em] text-[#D8B86A] uppercase mb-2">— Stock occasion{dispo ? ` · ${dispo} disponible${dispo > 1 ? "s" : ""}` : ""}</div>
            <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-[#072135] leading-[1.05] mb-4">
              Mini-pelles <span className="text-[#2877C2]">d'occasion</span> à vendre
            </h2>
            <p className="text-[#4B5563] text-base sm:text-lg leading-relaxed">
              Achetez une <strong className="text-[#072135]">mini-pelle d'occasion</strong> contrôlée près de Lyon et Grenoble : micro-pelles et mini-pelles de 1 à 3,5 tonnes,
              avec photos réelles, heures, godets fournis, état des chenilles et entretien détaillés. Prix affichés, sans surprise.
            </p>
          </div>
          <Link to={OCC_BASE} className="lmb-btn-outline self-start lg:self-end" data-testid="home-occasions-all">
            Toutes les occasions <ArrowRight size={16} />
          </Link>
        </div>

        {items && shown.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-testid="home-occasions-grid">
            {shown.map((o) => <OccasionCard key={o.id} o={o} />)}
          </div>
        )}
        {items && shown.length === 0 && (
          <div className="bg-[#F9F9F9] border border-dashed border-gray-300 rounded-sm p-8 sm:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between" data-testid="home-occasions-empty">
            <div>
              <div className="font-heading text-2xl font-black text-[#072135] mb-1">Nouvelles occasions très bientôt</div>
              <p className="text-[#4B5563]">Dites-nous ce que vous cherchez : nous vous appelons dès qu'une mini-pelle d'occasion correspond.</p>
            </div>
            <a href={`tel:${COMPANY.phoneTel}`} className="lmb-btn-primary shrink-0"><Phone size={15} /> {COMPANY.phone}</a>
          </div>
        )}

        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm font-semibold text-[#072135]">
          {POINTS.map(([Icon, t]) => <span key={t} className="inline-flex items-center gap-2"><Icon size={16} className="text-[#D8B86A]" /> {t}</span>)}
        </div>
      </div>
    </section>
  );
}
